﻿import { productComparerDto } from "../../models/productcomparer/productComparerDto";
import { productComparerProdArtDto } from "../../models/productcomparer/productComparerProdArtDto";
import { productComparerSwapProdArtDto } from "../../models/productcomparer/productComparerSwapProdArtDto";
import { getTranslations } from "../../translations";
import { sendApiCall } from "../../utilities/api";
import { getAuthRequestHeader, getUserApiAuthorize } from "../../utilities/api.userauth";
import { showNotification } from "../../utilities/notification";
import { sendDataLayer } from "../ecommerce/ecommerce";
import { ProductComparerPage } from "./productcomparer.page";
import { collapseProductComparer, ProductComparerPopup } from "./productcomparer.popup";

declare const localStorage: any;
const pcProdArtStorageKey = "compareprodarts";
const pcGetArticleStorageKey = "comparearticledto";
const pcGetArticleShowDiffStorageKey = "comparearticleshowdiff";

class ProductComparer
{
    currentPopup: ProductComparerPopup;

    constructor(initPopup: boolean)
    {
        if (initPopup)
            this.currentPopup = new ProductComparerPopup(this);
    }

    public resetCompareProdArts()
    {
        this.setProdArtStorage(JSON.stringify([]));
        this.checkProdCompareAddButtons();
    }

    public hasComparerProdArt(productID: number, articleID: number, prodArts?: Array<any> | null)
    {
        if (!prodArts)
            prodArts = this.getCompareProdArts();

        return prodArts.filter(x => x.productID == productID && x.articleID == articleID).length > 0;
    }

    public getCompareProdArts()
    {
        if (localStorage[pcProdArtStorageKey])
            return JSON.parse(localStorage[pcProdArtStorageKey]);
        else
        {
            this.resetCompareProdArts();
            return [];
        }
    }

    public storeCompareProdArts(prodArts, overwrite)
    {
        if (prodArts)
        {
            var storedProdArts = [];
            var newProdArts = [];

            if (!overwrite)
                storedProdArts = this.getCompareProdArts();

            // Check if item was already added first.
            for (var i = 0; i < prodArts.length; i++)
            {
                if (storedProdArts.length + newProdArts.length >= shopConfig().productCompareMaxCount)
                    break;

                var alreadyAdded = false;

                if (storedProdArts.length > 0)
                {
                    for (var i2 = 0; i2 < storedProdArts.length; i2++)
                    {
                        if (storedProdArts[i2].productID == prodArts[i].productID &&
                            storedProdArts[i2].articleID == prodArts[i].articleID)
                        {
                            alreadyAdded = true;
                            break;
                        }
                    }
                }

                if (!alreadyAdded)
                    newProdArts.push(prodArts[i]);
            }

            if (newProdArts.length > 0)
            {
                if (newProdArts.length == 1)
                    $(".js-productcomparer-show").addClass("disabled");
                else
                    $(".js-productcomparer-show").removeClass("disabled");

                storedProdArts = storedProdArts.concat(newProdArts);
                this.setProdArtStorage(JSON.stringify(storedProdArts));

                if (this.currentPopup !== undefined)
                    this.currentPopup.initProductCompareStickySummary(true);
            }

            this.checkProdCompareAddButtons();
        }
    }

    public removeCompareProdArts(prodArts)
    {
        if (prodArts)
        {
            var storedProdArts = this.getCompareProdArts();

            // Check if there's anything to remove first.
            if (storedProdArts.length > 0)
            {
                var removedAny = false;
                var existingItemIndex = -1;

                // Check if item was already added first.
                for (var i = 0; i < prodArts.length; i++)
                {
                    existingItemIndex = -1;

                    for (var i2 = 0; i2 < storedProdArts.length; i2++)
                    {
                        if (storedProdArts[i2].productID == prodArts[i].productID &&
                            storedProdArts[i2].articleID == prodArts[i].articleID)
                        {
                            existingItemIndex = i2;
                            break;
                        }
                    }

                    if (existingItemIndex >= 0)
                    {
                        storedProdArts.splice(existingItemIndex, 1);
                        removedAny = true;
                    }
                }

                if (removedAny)
                {
                    this.setProdArtStorage(JSON.stringify(storedProdArts));

                    if (storedProdArts.length > 0)
                    {
                        if (storedProdArts.length == 1)
                            $(".js-productcomparer-show").addClass("disabled");
                        else
                            $(".js-productcomparer-show").removeClass("disabled");

                        this.currentPopup.initProductCompareStickySummary(true);
                    }
                    else
                        $(".js-productcomparer-widget").remove();
                }
            }

            this.checkProdCompareAddButtons();
        }
    }

    private setProdArtStorage(value)
    {
        localStorage.setItem(pcProdArtStorageKey, value);

        // Clear stored GetArticle result.
        removeStoredArticleData();
    }

    private setStoredArticleData(value, showDifferenceOnly)
    {
        localStorage.setItem(pcGetArticleStorageKey, value);
        localStorage.setItem(pcGetArticleShowDiffStorageKey, showDifferenceOnly);
    }

    public getStoredArticleData(showDifferenceOnly)
    {
        const storedShowDiff = localStorage.getItem(pcGetArticleShowDiffStorageKey) === "true";

        if (storedShowDiff == showDifferenceOnly)
            return localStorage.getItem(pcGetArticleStorageKey);
        // Clear stored data if show difference was changed.
        else
        {
            removeStoredArticleData();
            return null;
        }
    }

    public swapCompareProdArt(swapProdArtDto: productComparerSwapProdArtDto, forPopup)
    {
        if (swapProdArtDto &&
            swapProdArtDto.removeProductID > 0 &&
            swapProdArtDto.removeArticleID > 0 &&
            swapProdArtDto.addProductID > 0 &&
            swapProdArtDto.addArticleID > 0)
        {
            var storedProdArts = this.getCompareProdArts();

            // Find product/article that was swapped, update its values, and re-store the stored product articles.
            if (storedProdArts.length > 0)
            {
                for (var i = 0; i < storedProdArts.length; i++)
                {
                    if (storedProdArts[i].productID == swapProdArtDto.removeProductID &&
                        storedProdArts[i].articleID == swapProdArtDto.removeArticleID)
                    {
                        storedProdArts[i].productID = swapProdArtDto.addProductID;
                        storedProdArts[i].articleID = swapProdArtDto.addArticleID;

                        this.setProdArtStorage(JSON.stringify(storedProdArts));
                        break;
                    }
                }
            }

            var popupParam = null;

            if (forPopup)
                popupParam = { productID: swapProdArtDto.addProductID, articleID: swapProdArtDto.addArticleID } as productComparerProdArtDto;

            new ProductComparerPage(this, { toggleDiff: false, skipRetrievingProdArt: false, articles: [popupParam] });
        }
        else
            $(".prodcomp-article-outer-wrapper").removeClass("disabled");
    }

    public checkProdCompareAddButtons = () =>
    {

        const prodArts = this.getCompareProdArts();

        // Reset all add holders.
        $(`.js-productcompare-toggle`).each(function (index, item)
        {
            $(item).removeClass("added");
            $(item).find("[type=checkbox]").prop("checked", false);
            $(item).find("[type=checkbox]").removeAttr("checked");
        });

        if (prodArts.length > 0)
        {
            // Set all add holders whose articles were added, as added.
            prodArts.forEach((item, index) =>
            {
                $(`.js-productcompare-toggle[data-articleid=${item.articleID}]`).addClass("added");
                $(`.js-productcompare-toggle[data-articleid=${item.articleID}] [type='checkbox']`).prop("checked", true);
                $(`.js-productcompare-toggle[data-articleid=${item.articleID}] [type='checkbox']`).attr("checked", "checked");
            });
        }

        const comparer = this;

        // Add events
        $(".js-productcompare-toggle").off("change");
        $(".js-productcompare-toggle").on("change", function ()
        {
            const productID = $(this).data("productid");
            const articleID = $(this).data("articleid");
            const articleNumber = $(this).data("articlenumber");

            if (!comparer.toggleProductComparerArticle(productID, articleID, articleNumber, true))
                $(this).find("[type=checkbox]").prop("checked", false);
        });
    };

    private toggleProductComparerArticle(productID, articleID, articleNumber, decollapseSticky): boolean
    {
        if (this.hasComparerProdArt(productID, articleID))
            this.removeProductComparerArticle(productID, articleID, articleNumber);
        else
        {
            if (!this.addProductComparerArticle(productID, articleID, articleNumber, false))
                return false;
            else if (decollapseSticky)
                collapseProductComparer(false);
        }
        return true;
    }

    public loadProductComparerArticles(resultHandler, skipMismatchCheck)
    {
        const instance = this;
        if (getUserApiAuthorize())
        {
            var callback = function (responseData, responseState)
            {
                var loadedProdArtsDto = {
                    productArticles: []
                };

                if (responseState === "success" &&
                    responseData
                )
                    loadedProdArtsDto.productArticles = responseData.productArticles;

                var mismatchFound = false;
                var localProdArts = instance.getCompareProdArts();

                if (localProdArts.length > 0)
                {
                    // Check for mismatch if both local and API/DB has items.
                    if (loadedProdArtsDto.productArticles.length > 0)
                        mismatchFound = instance.checkProdArtsMismatch(localProdArts, loadedProdArtsDto.productArticles);
                    // When no items were found in API/DB, but there are local ones, add all local ones to the DB.
                    else
                        instance.addProductComparerArticles(localProdArts, true);
                }

                if (!skipMismatchCheck && mismatchFound)
                    instance.initProductCompareMismatchPopup(localProdArts, loadedProdArtsDto.productArticles, resultHandler);
                // No mismatches found; continue as usual.
                else
                {
                    instance.storeCompareProdArts(loadedProdArtsDto.productArticles, true);

                    if (resultHandler &&
                        resultHandler.handleFunction
                    )
                        resultHandler.handleFunction();
                }
            }

            sendApiCall({
                callType: "GET",
                endpoint: "/WebshopProductComparer/load-articles",
                rawUrl: location.pathname,
                callback: callback,
                beforeSend: getAuthRequestHeader(false),
            });
        }
        else
            resultHandler.handleFunction();
    }

    public checkProdArtsMismatch(prodArtFirst, prodArtSecond)
    {
        var mismatchFound = false;

        // If one isn't set or empty, don't count as mismatch.
        if (prodArtFirst &&
            prodArtSecond &&
            prodArtFirst.length > 0 &&
            prodArtSecond.length > 0)
        {
            // Difference in length means mismatch.
            if (prodArtFirst.length != prodArtSecond.length)
                mismatchFound = true;
            else
            {
                // Loop all items for the lists and check if all of them have a match with each other.
                for (var i = 0; i < prodArtFirst.length; i++)
                {
                    // Don't check if mismatch was found.
                    if (!mismatchFound)
                    {
                        var currentMatchFound = false;

                        for (var i2 = 0; i2 < prodArtSecond.length; i2++)
                        {
                            // Matching product- and article ID means match between both lists.
                            if (prodArtFirst[i].productID == prodArtSecond[i2].productID &&
                                prodArtFirst[i].articleID == prodArtSecond[i2].articleID)
                            {
                                currentMatchFound = true;
                                break;
                            }
                        }

                        if (!currentMatchFound)
                        {
                            mismatchFound = true;
                            break;
                        }
                    }

                    if (mismatchFound)
                        break;
                }
            }
        }

        return mismatchFound;
    }

    public initProductCompareMismatchPopup(localArticles, dbArticles, resultHandler)
    {
        var allArticles = localArticles.concat(
            dbArticles.filter((locArt) =>
                localArticles.findIndex((dbArt) =>
                    dbArt.productID == locArt.productID &&
                    dbArt.articleID == locArt.articleID
                ) < 0
            )
        );

        var mismatchModalHandler = function (articleData)
        {
            return this.loadProductCompareMismatchData(articleData, localArticles, dbArticles, resultHandler);
        }

        this.getProductComparerArticles(this.currentPopup, false, false, allArticles, resultHandler, mismatchModalHandler);
    }

    public addProductComparerArticle(productID, articleID, articleNumber, deleteExisting)
    {
        return this.addProductComparerArticles([{ productID: productID, articleID: articleID, articleNumber: articleNumber }], deleteExisting);
    }

    private addProductComparerArticles(productArticles, deleteExisting)
    {
        if (!productArticles)
            return false;

        const currentArticleCount = this.getCompareProdArts().length;
        if (currentArticleCount >= shopConfig().productCompareMaxCount)
        {
            showNotification({ status: "warning", message: getTranslations().txtProdCompMaxCompare, timeout: 5000, group: 'productcomparer' });
            return false;
        }

        var newProdArtsDto = new productComparerDto({
            deleteExisting: deleteExisting,
            productArticles: []
        });

        // Loop all items to add them.
        for (var i = 0; i < productArticles.length; i++)
        {
            // Don't add more than allowed by config setting.
            if (currentArticleCount + newProdArtsDto.productArticles.length >= shopConfig().productCompareMaxCount)
                break;

            var newProdArt = new productComparerProdArtDto({
                productID: productArticles[i].productID,
                articleID: productArticles[i].articleID
            });

            newProdArtsDto.productArticles.push(newProdArt);

            if (productArticles[i].articleNumber)
            {
                sendDataLayer({
                    "category": "productcomparer",
                    "action": "Add article",
                    "label": productArticles[i].articleNumber,
                    "url": window.location.pathname,
                    "event": "Click"
                });
            }
        }

        // Logged in, send API call and if success, add to local storage.
        if (getUserApiAuthorize())
        {
            const callback = (responseData, responseState): void =>
            {
                if (responseState === "success")
                {
                    if (!localStorage[pcProdArtStorageKey] || deleteExisting)
                    {
                        this.resetCompareProdArts();
                    }

                    this.storeCompareProdArts(newProdArtsDto.productArticles, false);
                }
            };

            sendApiCall({ endpoint: "/WebshopProductComparer/add-articles", rawUrl: location.pathname, callback: callback, customDto: newProdArtsDto, beforeSend: getAuthRequestHeader(false) });
        }
        // Not logged in, immediately add to local storage.
        else
        {
            if (!localStorage[pcProdArtStorageKey] || deleteExisting)
            {
                this.resetCompareProdArts();
            }

            this.storeCompareProdArts(newProdArtsDto.productArticles, false);
        }
        return true;
    }

    public removeProductComparerArticle(productID, articleID, articleNumber)
    {
        return this.removeProductComparerArticles([{ productID: productID, articleID: articleID, articleNumber: articleNumber }], false);
    }

    public removeProductComparerArticles(productArticles: Array<productComparerProdArtDto>, removeAll)
    {
        if (!productArticles)
            return false;

        var removeProdArtsDto = new productComparerDto({
            productArticles: []
        });

        // Loop all items to remove them.
        for (var i = 0; i < productArticles.length; i++)
        {
            var removeProdArt = new productComparerProdArtDto({
                productID: productArticles[i].productID,
                articleID: productArticles[i].articleID
            });

            removeProdArtsDto.productArticles.push(removeProdArt);

            if (!removeAll &&
                productArticles[i].articleNumber)
            {
                sendDataLayer({
                    "category": "productcomparer",
                    "action": "Remove article",
                    "label": productArticles[i].articleNumber,
                    "url": window.location.pathname,
                    "event": "Click"
                });
            }
        }

        if (removeAll)
        {
            $(".js-productcomparer-widget").remove();

            sendDataLayer({
                "category": "productcomparer",
                "action": "Remove all",
                "url": window.location.pathname,
                "event": "Click"
            });

            if ($("#productcomparerpreviouspage a").length > 0)
                $("#productcomparerpreviouspage a").trigger('click');
        }

        const instance = this;

        // Logged in, send API call and if success, remove from local storage.
        if (getUserApiAuthorize())
        {
            var callback = function (responseData, responseState)
            {
                if (responseState === "nocontent")
                    instance.removeCompareProdArts(removeProdArtsDto.productArticles);
            }

            sendApiCall({ endpoint: "/WebshopProductComparer/remove-articles", rawUrl: location.pathname, callback: callback, customDto: removeProdArtsDto, beforeSend: getAuthRequestHeader(false), callType: "DELETE" });
        }
        // Not logged in, immediately remove from local storage.
        else
            instance.removeCompareProdArts(removeProdArtsDto.productArticles);
    }

    public getProductComparerArticles(source, showDifferenceOnly, showDifferenceToggled, productArticlesOverride, resultHandler, showPopupProdArt)
    {
        // Re-retrieve data if show differences is toggled.
        if (showDifferenceToggled)
            removeStoredArticleData();

        var productArticles = [];

        if (productArticlesOverride)
            productArticles = productArticlesOverride;
        else
            productArticles = this.getCompareProdArts();

        if (!productArticles ||
            productArticles.length == 0
        )
            return false;

        var searchProdArtsDto = new productComparerDto({
            showDifferenceOnly: showDifferenceOnly,
            productArticles: []
        });

        // Loop all items to add them.
        for (var i = 0; i < productArticles.length; i++)
        {
            var searchProdArt = new productComparerProdArtDto({
                productID: productArticles[i].productID,
                articleID: productArticles[i].articleID
            });

            searchProdArtsDto.productArticles.push(searchProdArt);
        }

        try
        {
            var storedDataJson = this.getStoredArticleData(showDifferenceOnly);

            if (storedDataJson)
            {
                var storedData = JSON.parse(storedDataJson);

                if (storedData &&
                    storedData.articles &&
                    Array.isArray(storedData.articles))
                {
                    if (resultHandler)
                    {
                        resultHandler(source, storedData, showDifferenceToggled, showPopupProdArt);
                        return true;
                    }
                }
            }
        } catch (e)
        {
            return;
        }

        const comparer = this;

        var callback = function (articleData, responseState)
        {
            if (responseState === "success" && articleData)
            {
                comparer.setStoredArticleData(JSON.stringify(articleData), showDifferenceOnly);

                if ($(articleData).length > 0 && resultHandler)
                    resultHandler(source, articleData, showDifferenceToggled, showPopupProdArt);
                //else
                //    window.location.replace("/");
            }
            else
            {
                removeStoredArticleData();
                // window.location.replace("/");
            }
        }

        sendApiCall({
            endpoint: "/WebshopProductComparer/get-articles",
            rawUrl: location.pathname,
            callback: callback,
            customDto: searchProdArtsDto,
            beforeSend: getAuthRequestHeader(false)
        });
    }
}

const pushProdCompArticleCart = (articleNumber) =>
{
    sendDataLayer({
        "category": "productcomparer",
        "action": "Add to cart",
        "label": articleNumber,
        "url": window.location.pathname,
        "event": "Click"
    });
}

const clearProductComparer = () =>
{
    localStorage.removeItem(pcProdArtStorageKey);
    removeStoredArticleData();
    $(".js-productcomparer-widget").remove();
    $(".js-productcompare-toggle").removeClass("added");

    $(".js-productcompare-toggle").find("input[type=checkbox").prop("checked", false);
}

const removeStoredArticleData = () =>
{
    localStorage.removeItem(pcGetArticleStorageKey);
    localStorage.removeItem(pcGetArticleShowDiffStorageKey);
}

export { ProductComparer, removeStoredArticleData, clearProductComparer, pushProdCompArticleCart };
(window as any).removeStoredArticleData = removeStoredArticleData;
(window as any).clearProductComparer = clearProductComparer;
(window as any).pushProdCompArticleCart = pushProdCompArticleCart;
